/*
  Einrichtungsberater – natives Quiz im Theme (snippets/cx-berater.liquid).

  Ablauf: Gruppe wählen (Bett, Sofa & Sessel, Matratzen & Schlafen, Garten, Möbel, Deko, Kinder) → der Produkt-Index
  der Gruppe wird geladen (JSON in den Shop-Dateien, täglich per Job aus den Produktdaten gebaut, siehe
  apps/lb24-checkout/build_quiz_index.py) → ein paar Fragen (Größe, Platz in cm, Stauraum, Bezug, Farbe, Härtegrad,
  Budget …) → jedes Produkt bekommt eine Punktzahl aus harten Kriterien (passt in den Platz, Größe lieferbar,
  Budget) und weichen (Farbe, Bezug, Stil, Extras, Beliebtheit, Bewertung, Lieferzeit) → beste Treffer mit
  „Warum passt das“-Chips direkt in der Karte.

  Felder im Index pro Produkt: id, h, t, img, pmin, pmax, cat, form, stau, ex[], fin, sz[], col[], mat[], hg[],
  d{b,t,h,l,kh,sh,st,md,lh}, pl, mt, mtyp, ttyp, btyp, stil, st[], mc, ko, kw, s30, r, rc, lt, q{q1..q7}, tags[]
*/
(function () {
  'use strict';

  var ROOT_SEL = '[data-cx-berater]';
  var CDN = 'https://cdn.shopify.com/s/files/1/0416/8197/7495/';
  var imgUrl = function (path, w) { if (!path) return ''; var u = /^https?:/.test(path) ? path : CDN + path; return u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (w || 600); };
  var money = function (n) {
    if (n == null) return '';
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: n % 1 ? 2 : 0 }).format(n);
  };
  var norm = function (s) { return String(s || '').toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss'); };
  var has = function (list, re) { return (list || []).some(function (v) { return re.test(norm(v)); }); };
  var txt = function (p) { return norm([p.t, p.cat, p.ko, p.kw, p.fin, p.mc, p.btyp, p.mtyp, p.ttyp, p.stil].concat(p.ex || [], p.mat || []).join(' | ')).replace(/luxusbetten ?24|minecraft x/g, ''); };
  var sizeWidth = function (sz) { var m = /^(\d+)\s*x\s*(\d+)/.exec(sz || ''); return m ? Number(m[1]) : null; };
  var sizeLength = function (sz) { var m = /^(\d+)\s*x\s*(\d+)/.exec(sz || ''); return m ? Number(m[2]) : null; };

  // ---------- Farben: Chips → Index-Werte (Optionswerte „Farbe“, sehr unterschiedlich geschrieben) ----------
  var COLORS = [
    { v: 'beige', label: 'Beige & Sand', re: /beige|sand|creme|cream|ivory|natur|ecru|champagner/ },
    { v: 'grau', label: 'Grau', re: /grau|grey|gray|silber|charcoal|anthra/ },
    { v: 'schwarz', label: 'Schwarz', re: /schwarz|black/ },
    { v: 'weiss', label: 'Weiß', re: /weiss|white|weiß/ },
    { v: 'braun', label: 'Braun & Cognac', re: /braun|brown|cognac|taupe|mocca|mokka|umber|sienna|karamell|caramel/ },
    { v: 'gruen', label: 'Grün', re: /gruen|green|olive|salbei|sage|mint|petrol|smaragd/ },
    { v: 'blau', label: 'Blau', re: /blau|blue|navy|petrol|tuerkis|turquoise|prussian/ },
    { v: 'rose', label: 'Rosé & Pink', re: /rose|rosa|pink|blush|mauve|altrosa|flieder|lila|lavend/ },
    { v: 'rot', label: 'Rot & Bordeaux', re: /rot|red|bordeaux|wein|terrakotta|terracotta|orange|amber|safran|senf|gelb|yellow|gold/ },
  ];
  function colorMatch(p, wanted) {
    if (!wanted || !wanted.length) return null;
    var cols = (p.col && p.col.length) ? p.col : (p.tags || []).filter(function (t) { return /^Farbe_/.test(t); }).map(function (t) { return t.slice(6); });
    if (!cols.length) cols = [p.t];
    var hit = null;
    wanted.forEach(function (w) {
      var c = COLORS.filter(function (x) { return x.v === w; })[0];
      if (!c || hit) return;
      var matches = cols.filter(function (x) { return c.re.test(norm(x)); });
      var found = matches.filter(function (x) { return p.ci && p.ci[x]; })[0] || matches[0];
      if (found) hit = found === p.t ? c.label : found;
    });
    return hit;
  }

  // ---------- Stil: Frage in allen Gruppen; Abgleich über q3_allowed (Betten) und sonst über Material/Farbe/Titel ----------
  var STYLES = [
    { v: 'modern', label: 'Modern & klar', sub: 'Gerade Linien, ruhige Farben', key: 'modern_clean', re: /modern|minimal|clean|puristisch|schlicht|geradlinig|schwarz|weiss|grau|anthrazit|metall|glas|beton/ },
    { v: 'skandi', label: 'Skandinavisch & natürlich', sub: 'Holz, helle Töne, Leinen', key: 'scandinavic', re: /skandi|scandi|natur|holz|eiche|birke|leinen|beige|sand|creme|hell|rattan|jute|baumwolle/ },
    { v: 'cozy', label: 'Gemütlich & weich', sub: 'Bouclé, Teddy, Cord, runde Formen', key: 'cozy', re: /cozy|gemuetlich|kuschel|boucl|teddy|cord|weich|lounge|plueschig|plush|hochflor/ },
    { v: 'luxus', label: 'Elegant & luxuriös', sub: 'Samt, Leder, Gold, Marmor', key: 'luxurious', re: /luxus|luxur|elegant|edel|samt|velvet|leder|gold|messing|marmor|chester|glam|kristall|premium/ },
    { v: 'trend', label: 'Trend- & Instagram-Look', sub: 'Organische Formen, Creme, Bouclé', key: 'aesthetic_ig', re: /trend|insta|organisch|rund|curved|boucl|creme|cream|ivory|wolke|cloud|designer/ },
    { v: 'bunt', label: 'Ausdrucksstark & farbig', sub: 'Kräftige Farben, Muster', key: 'expressive_rich', re: /bunt|farbig|muster|gelb|orange|petrol|senf|terrakotta|pink|lila|kobalt|smaragd|statement|retro|70er/ },
  ];
  // Beispiele unter den Stil-Chips passend zur Produktgruppe – wer eine Vase sucht, bekommt nicht „Bouclé, Teddy, Cord“ angeboten.
  var STYLE_SUBS = {
    polster: { modern: 'Gerade Linien, ruhige Farben', skandi: 'Helle Töne, Leinen, Holzfüße', cozy: 'Bouclé, Teddy, Cord, runde Formen', luxus: 'Samt, Leder, Gold', trend: 'Organische Formen, Creme, Bouclé', bunt: 'Kräftige Farben, Muster' },
    moebel:  { modern: 'Gerade Linien, Schwarz, Weiß, Metall & Glas', skandi: 'Helles Holz, Eiche, Leinen', cozy: 'Weiche Formen, warme Töne', luxus: 'Marmor, Gold, Messing, Glas', trend: 'Organische Formen, Creme, Travertin', bunt: 'Kräftige Farben, Muster' },
    deko:    { modern: 'Klare Formen, Schwarz, Weiß, Grau', skandi: 'Keramik, Holz, helle Naturtöne', cozy: 'Warme Töne, weiche, runde Formen', luxus: 'Gold, Marmor, Glas', trend: 'Organische Formen, Creme, Travertin', bunt: 'Kräftige Farben, Muster' },
    garten:  { modern: 'Aluminium, klare Linien, Grau', skandi: 'Teak & Akazie, Naturtöne', cozy: 'Weiche Polster, warme Töne', luxus: 'Großzügig, edle Materialien', trend: 'Organische Formen, Creme', bunt: 'Kräftige Farben, Muster' }
  };
  function styleStep(id, kind) {
    var subs = STYLE_SUBS[kind] || STYLE_SUBS.polster;
    return { id: id, title: 'Welcher Einrichtungsstil gefällt dir?', type: 'single', cols: 2, options: STYLES.map(function (x) { return { v: x.v, label: x.label, sub: subs[x.v] || x.sub }; }).concat([SKIP]) };
  }
  function styleMatch(p, v) {
    var st = STYLES.filter(function (x) { return x.v === v; })[0];
    if (!st) return 0;
    var keys = (p.q && (p.q.q3 || p.q.q4)) || null;
    if (keys && keys.length) return keys.some(function (k) { return k.indexOf(st.key) >= 0; }) ? 2 : -1;   // gepflegte Stil-Zuordnung
    var pool = norm([p.t, p.fin, p.mc, p.cat].concat(p.col || [], p.mat || []).join(' '));
    return st.re.test(pool) ? 1 : 0;
  }
  // Variantenbild in der gewünschten Farbe (sonst Hauptbild) + Name der getroffenen Farbe
  function colorImage(p, wanted, preferName) {
    if (!wanted || !wanted.length || !p.ci) return null;
    if (preferName && p.ci[preferName]) return { url: p.ci[preferName], name: preferName };
    for (var i = 0; i < wanted.length; i++) {
      var c = COLORS.filter(function (x) { return x.v === wanted[i]; })[0];
      if (!c) continue;
      var keys = Object.keys(p.ci).filter(function (k) { return c.re.test(norm(k)); });
      if (keys.length) return { url: p.ci[keys[0]], name: keys[0] };
    }
    return null;
  }

  // ---------- Bezug / Material ----------
  var FABRICS = [
    { v: 'samt', label: 'Samt', re: /samt|velvet|velour/ },
    { v: 'boucle', label: 'Bouclé & Teddy', re: /boucl|teddy|lammfell|sherpa/ },
    { v: 'cord', label: 'Cord', re: /cord|corduroy/ },
    { v: 'chenille', label: 'Chenille', re: /chenille/ },
    { v: 'stoff', label: 'Stoff & Leinen', re: /stoff|leinen|linen|webstoff|strukturstoff|jacquard|gewebt|polyester|textil/ },
    { v: 'leder', label: 'Leder', re: /leder|leather/ },
  ];
  var MATERIALS = [
    { v: 'holz', label: 'Holz', re: /holz|eiche|oak|teak|akazie|acacia|kiefer|buche|walnuss|mango|bambus|rattan|weide|sheesham|mdf/ },
    { v: 'polyrattan', label: 'Polyrattan & Geflecht', re: /rattan|geflecht|wicker|korb/ },
    { v: 'metall', label: 'Metall & Aluminium', re: /metall|metal|alu|stahl|steel|eisen|iron|messing|chrom/ },
    { v: 'stein', label: 'Marmor & Stein', re: /marmor|marble|stein|stone|beton|keramik|terrazzo|travertin/ },
    { v: 'glas', label: 'Glas', re: /glas|glass/ },
    { v: 'textil', label: 'Textil & Polster', re: /stoff|textil|polster|samt|boucl|cord|baumwolle|wolle|polyester|leinen/ },
    { v: 'kunststoff', label: 'Kunststoff', re: /kunststoff|plastik|polypropylen|pvc|resin/ },
  ];
  function fabricMatch(p, v) {
    var f = FABRICS.filter(function (x) { return x.v === v; })[0];
    if (!f) return null;
    // Titel zuerst („… in Cord“), dann Finish-Metafeld / Material-Option
    var titleFabric = FABRICS.filter(function (x) { return x.re.test(norm(p.t)); });
    if (titleFabric.length) return titleFabric.some(function (x) { return x.v === v; }) ? f.label : null;
    var pool = [p.fin].concat(p.mat || []);
    if (has(pool, f.re)) return f.label;
    return null;
  }
  function materialMatch(p, v) {
    var m = MATERIALS.filter(function (x) { return x.v === v; })[0];
    if (!m) return null;
    var pool = [p.fin, p.mc, p.t].concat(p.mat || []);
    if (has(pool, m.re)) return m.label;
    return null;
  }

  // ---------- Maße: Breite/Länge/Tiefe eines Produkts (cm) ----------
  var dim = function (p, k, min) { var v = p.d && p.d[k]; return typeof v === 'number' && v >= (min || 20) ? v : null; };
  // Betten: Außenbreite (Liegebreite, wenn „Breite insgesamt“ fehlt) und Gesamtlänge
  function bedWidth(p, chosenSize) {
    var b = dim(p, 'b', 70);
    var w = chosenSize ? sizeWidth(chosenSize) : null;
    if (b && (!w || b >= w)) return b;
    if (w) return w;
    var ws = (p.sz || []).map(sizeWidth).filter(Boolean);
    return ws.length ? Math.min.apply(null, ws) : null;
  }
  function bedLength(p, chosenSize) {
    var l = dim(p, 'l', 150) || (dim(p, 't', 150)); // bei Betten ist „Tiefe“ die Gesamtlänge
    if (l) return l;
    if (p.pl && p.pl >= 150) return p.pl;
    if (chosenSize) { var sl = sizeLength(chosenSize); if (sl) return sl + 10; }
    return null;
  }
  // Möbel/Sofas/Garten: lange Seite (Breite/Länge) und kurze Seite (Tiefe)
  function longSide(p) { var c = [dim(p, 'b'), dim(p, 't'), dim(p, 'l'), p.pl && p.pl >= 20 ? p.pl : null].filter(Boolean); return c.length ? Math.max.apply(null, c) : null; }
  function shortSide(p) { var b = dim(p, 'b'), t = dim(p, 't'); return b && t ? Math.min(b, t) : (t || null); }
  function fitReason(w, d) { return 'Passt in deinen Platz' + (w || d ? ' (' + [w ? w + ' cm breit' : null, d ? d + ' cm tief' : null].filter(Boolean).join(', ') + ')' : ''); }

  // ---------- Fragen-Bausteine ----------
  var SKIP = { v: '__skip', label: 'Egal / Überspringen' };
  function budgetStep(id, steps) {
    return { id: id, title: 'Wie viel möchtest du ungefähr ausgeben?', type: 'single', cols: 3,
      options: steps.map(function (n) { return { v: String(n), label: 'bis ' + money(n) }; }).concat([{ v: '__skip', label: 'Offen' }]) };
  }
  function colorStep(id) {
    return { id: id, title: 'Welche Farbe passt zu dir?', hint: 'Mehrere möglich.', type: 'multi', cols: 3,
      options: COLORS.map(function (c) { return { v: c.v, label: c.label }; }).concat([SKIP]) };
  }
  function spaceStep(id, title, fields) {
    return { id: id, title: title, hint: 'Optional – damit zeigen wir nur, was wirklich passt.', type: 'dims', fields: fields };
  }


  // ---------- Produktart: Produkttyp (cat) zuerst, dann Titel – nie Keywords/Kollektionen (sonst landet ein Teppich
  // bei „Vasen“, weil irgendwo „Schale“ im Text steht). Jede Art: cat (Regex auf Produkttyp), title (Regex auf Titel),
  // not (Ausschluss auf Typ + Titel).
  function typeOk(p, def) {
    if (!def) return true;
    var cat = norm(p.cat || ''), title = norm(p.t || '');
    if (def.not && def.not.test(cat + ' | ' + title)) return false;
    if (def.cat && cat && def.cat.test(cat)) return true;
    if (def.title && def.title.test(title)) return true;
    return false;
  }
  var TYPES = {
    schlafen: {
      matratze: { cat: /^matratze|federkern|schaum/, title: /matratze/, not: /topper|kissen|baby|auflage|schoner|bezug/ },
      topper: { cat: /topper/, title: /topper/, not: /matratze\b(?!.*topper)/ },
      kissen: { cat: /^kissen$|nackenst|kopfkissen|schlafkissen/, title: /nackenstuetz|nackenkissen|kopfkissen|schlafkissen|^kissen/, not: /zier|stuhl|sitz|garten|lounge|bezug|sofa|sessel|box/ },
      lattenrost: { cat: /^lattenrost/, title: /lattenrost/, not: /bett\b|boxspring|polsterbett|matratze/ },
      bettwaren: { cat: /bettw|bettdecke|decke|laken|tagesdecke|kissenbez/, title: /bettw|bettdecke|laken|tagesdecke|bettbezug|spannbett/, not: /garten|lounge|outdoor/ }
    },
    garten: {
      lounge: { cat: /lounge|gartensofa|daybed/, title: /gartenlounge|lounge|gartensofa|outdoor.?sofa|daybed/, not: /sessel\b(?!.*set)|stuhl|kissen|huelle|schutz/ },
      essen: { cat: /essgruppe|esstisch|gartentisch|cafegruppe|cafe.?set|bartisch|outdoor-tische/, title: /essgruppe|esstisch|gartentisch|bartisch|cafe.?set|bistro.?set/, not: /beistell|couch|ablage/ },
      sitzen: { cat: /gartenstuhl|stuhl|bank|sessel|hocker|schaukel|outdoor-st|outdoor-b/, title: /gartenstuhl|stuhl|stuehle|gartenbank|bank|sessel|hocker|hollywoodschaukel/, not: /kissen|auflage|huelle|lounge\b(?!sessel)/ },
      liegen: { cat: /liege|haengematte|haengesessel|daybed/, title: /sonnenliege|liege|haengematte|haengesessel|daybed/, not: /kissen|auflage|huelle/ },
      balkon: { cat: /balkon|cafe|bistro/, title: /balkon|cafe.?set|bistro/ },
      feuer: { cat: /feuer|grill|pizza|heiz|ofen|brennholz/, title: /feuerstelle|feuerkorb|feuerschale|grill|pizzaofen|heizstrahler|heizpilz|terrassenofen|brennholz/ },
      schatten: { cat: /schirm|pergola|pavillon|markise|segel/, title: /sonnenschirm|schirm|pergola|pavillon|markise|sonnensegel/ },
      deko: { cat: /lampe|leuchte|laterne|topf|pflanz|stuhlkissen|sitzkissen|teppich|auflagenbox|kissenbox|schutzh|deko|solar/, title: /lampe|leuchte|laterne|blumentopf|pflanzk|teppich|auflagenbox|kissenbox|sitzkissen|stuhlkissen|schutzhuelle|windlicht|solar/, not: /gartenstuhl|loungesessel|gartenlounge|loungeset|sonnenliege|esstisch|essgruppe|daybed/ }
    },
    wohnen: {
      esstisch: { cat: /^esstisch|esszimmertisch/, title: /esstisch|esszimmertisch|dining/, not: /couch|beistell|nacht|lampe|stuhl|schreibtisch|konsole/ },
      couchtisch: { cat: /couchtisch|beistelltisch|sofatisch|ablagetisch/, title: /couchtisch|beistelltisch|sofatisch|satztisch|ablagetisch/, not: /lampe|esstisch|nachttisch|garten/ },
      stuhl: { cat: /stuhl|stuehle|hocker|pouf|bank|baenke/, title: /stuhl|stuehle|hocker|pouf|sitzbank|essbank|esszimmerbank/, not: /garten|kissen|tisch\b/ },
      kommode: { cat: /kommode|sideboard|highboard/, title: /kommode|sideboard|highboard/ },
      schrank: { cat: /schrank|garderobe/, title: /schrank|garderobe/, not: /wein|schuh|regal/ },
      regal: { cat: /regal|vitrine|buecherregal/, title: /regal|vitrine/, not: /garderobe/ },
      tv: { cat: /tv|lowboard|wohnwand|fernseh/, title: /tv.?lowboard|lowboard|wohnwand|fernseh|tv-?moebel|tv-?schrank|tv-?board/ },
      lampe: { cat: /lampe|leuchte|licht/, title: /lampe|leuchte/ },
      nachttisch: { cat: /nachttisch|nachtkonsole/, title: /nachttisch|nachtkonsole|nachtschrank/ }
    },
    deko: {
      kissen: { cat: /^zierkissen|^kissen$|tagesdecke|plaid|kissenbez|^decke$/, title: /zierkissen|kissen|plaid|tagesdecke|wohndecke|kuscheldecke/, not: /stuhlkissen|sitzkissen|nackenst|garten|outdoor|abtropf|wanduhr|ablage/ },
      teppich: { cat: /teppich|laeufer|rechteckig|rund|oval|quadrat/, title: /teppich|laeufer/, not: /badematte|fussmatte|garten|outdoor/ },
      vase: { cat: /^vase|schale|tablett|krug|krueg|aufbewahrungsbeh|dose|uebertopf/, title: /\bvase|\bschale|\bschalen\b|tablett|\bkrug\b|\bkruege|\bdose\b|deko-?objekt/, not: /sitzschale|sessel|stuhl|lampe|leuchte|kerze|spiegel|abtropf|teppich|decke/ },
      kerze: { cat: /kerze|kerzenhalter|teelicht|laterne|windlicht|duftkerze/, title: /kerze|kerzenhalter|kerzenstaender|teelicht|laterne|windlicht/ },
      spiegel: { cat: /spiegel/, title: /\bspiegel/, not: /schrank|kommode|garderobe/ },
      bild: { cat: /poster|bild|wandpaneel|akustik|wanddeko|rahmen|wandbild/, title: /poster|wandbild|bild\b|wandpaneel|akustikpaneel|bilderrahmen|wanddeko/, not: /spiegel|schrank|kommode|regal|garderobe/ },
      pflanze: { cat: /pflanze|blumentopf|uebertopf|topf|pflanzen/, title: /kunstpflanze|pflanze|blumentopf|uebertopf|pflanzkuebel|pflanzenstaender/ },
      tisch: { cat: /geschirr|becher|teller|tasse|besteck|kueche|servier|kuechenware|krueg/, title: /geschirr|teller|tasse|becher|glaeser|trinkglas|weinglas|besteck|schuessel|serviett|platzset|karaffe|kanne|servierplatte|etagere/, not: /vase|kerze|lampe/ },
      textil: { cat: /gardine|vorhang|matte|badem|fussmatte|handtuch|hausschuh/, title: /gardine|vorhang|badematte|fussmatte|matte\b|handtuch|hausschuh/ }
    },
    kinder: {
      bett: { cat: /bett/, title: /kinderbett|babybett|juniorbett|hochbett|spielbett|hausbett|\bbett\b/, not: /bettw|decke|laken|kissen|tagesdecke/ },
      hochbett: { cat: /hochbett|etagenbett/, title: /hochbett|etagenbett|spielbett|hausbett/ },
      sofa: { cat: /sofa|sessel|hocker|sitzsack/, title: /kindersofa|sofa|sessel|hocker|sitzsack/, not: /kissen|bezug/ },
      tisch: { cat: /tisch|stuhl|stuehle|hocker/, title: /kindertisch|tisch|stuhl|stuehle/, not: /nacht|lampe|geschirr|tischdeko|tischset/ },
      deko: { cat: /deko|kissen|teppich|lampe|decke|bettw|regal|korb|koerbe|garderobe|spiel|puppe|pluesch|mobile|geschirr|becher|tasse|schaukel|buchst/, title: /./ }
    }
  };


  // ---------- Deko: Detailfragen je Art (Form, Material, Größe) – abgeglichen über Titel, Produkttyp und Material ----------
  // Jede Option: re = passt, not = passt sicher nicht (Produkt fällt raus), ohne Treffer bleibt das Produkt neutral.
  var DEKO_DETAIL = {
    vase: [
      { id: 'form', title: 'Welche Form soll die Vase haben?', options: [
        { v: 'schlank', label: 'Schlank & hoch', sub: 'Für einzelne Stiele, Pampasgras', re: /\bschlank|\bschmal|\bhoch\b|\bhohe\b|\bhoher\b|zylind|flasche|bottle|roehre|saeule|stabvase|bodenvase/, not: /schale|bowl|flach/ },
        { v: 'bauchig', label: 'Bauchig & rund', sub: 'Kugel, Krug, Amphore', re: /bauchig|rund|kugel|krug|amphore|ball|bubble|tonne|topf|dickbauch/, not: /schale|flach/ },
        { v: 'organisch', label: 'Organisch & skulptural', sub: 'Unregelmäßige Formen, Objekt-Charakter', re: /organisch|skulptur|objekt|asymm|gewellt|wellen|flow|twist|donut|ring|gesicht|face|koerper|body|torso|unregelm/ },
        { v: 'schale', label: 'Schale & flach', sub: 'Dekoschale, Tablett', re: /schale|bowl|tablett|teller|flach|platte/, not: /\bvase\b(?!.*schale)/ } ] },
      { id: 'material', title: 'Welches Material gefällt dir?', options: [
        { v: 'keramik', label: 'Keramik & Steingut', re: /keramik|steingut|steinzeug|porzellan|ton\b|terrakotta|terracotta|dolomit|glasiert/, not: /\bglas\b|metall|eisen|aluminium|messing|holz|mango/ },
        { v: 'glas', label: 'Glas', re: /\bglas|glass|kristall|recycl/, not: /keramik|steingut|metall|holz/ },
        { v: 'metall', label: 'Metall & Gold', re: /metall|eisen|aluminium|alu\b|messing|gold|edelstahl|stahl|zink|kupfer|chrom/, not: /keramik|steingut|\bglas\b|holz/ },
        { v: 'natur', label: 'Holz & Naturmaterial', re: /holz|mango|akazie|teak|bambus|rattan|seegras|jute|wasserhyazinthe|binsen|stein\b|marmor|travertin|beton|zement/, not: /\bglas\b|metall|keramik/ } ] } ],
    kissen: [
      { id: 'size', title: 'Welche Größe?', cols: 3, options: [
        { v: '40', label: '40 × 40', re: /\b40 ?x ?40|40x40/ }, { v: '45', label: '45 × 45', re: /\b45 ?x ?45/ }, { v: '50', label: '50 × 50', re: /\b50 ?x ?50/ },
        { v: '30x50', label: 'Länglich (30 × 50)', re: /\b30 ?x ?50|\b30 ?x ?60|\b35 ?x ?55|\b40 ?x ?60|laenglich|lendenkissen|nackenrolle/ }, { v: '60', label: 'Groß (60 × 60)', re: /\b60 ?x ?60|\b65 ?x ?65|\b70 ?x ?70|xl\b|bodenkissen/ },
        { v: 'decke', label: 'Decke / Plaid', re: /decke|plaid|tagesdecke/ } ] },
      { id: 'material', title: 'Welcher Stoff gefällt dir?', cols: 3, options: [
        { v: 'samt', label: 'Samt', re: /samt|velvet|velour/ }, { v: 'boucle', label: 'Bouclé & Teddy', re: /boucl|teddy|lammfell|kunstfell|fell|shaggy|flausch/ },
        { v: 'leinen', label: 'Leinen & Baumwolle', re: /leinen|baumwolle|cotton|canvas|webstoff|linen/ }, { v: 'strick', label: 'Strick & Wolle', re: /strick|wolle|woll|knit|gestrickt|alpaka/ },
        { v: 'muster', label: 'Gemustert & bestickt', re: /muster|bestickt|stick|print|bedruckt|streifen|karo|quaste|fransen|pompon/ } ] } ],
    spiegel: [
      { id: 'form', title: 'Welche Form soll der Spiegel haben?', options: [
        { v: 'rund', label: 'Rund', re: /rund|round|kreis|\bø|durchmesser/, not: /rechteck|eckig|quadrat|oval|organisch|standspiegel|ganzkoerper/ },
        { v: 'eckig', label: 'Eckig & rechteckig', re: /rechteck|eckig|quadrat|rahmen|wandspiegel/, not: /\brund|organisch|oval/ },
        { v: 'organisch', label: 'Organisch & asymmetrisch', re: /organisch|asymm|unregelm|wellen|pond|wolke|cloud|form\b|bogen|arch|oval/ },
        { v: 'stand', label: 'Standspiegel & Ganzkörper', re: /standspiegel|ganzkoerper|ganzkörper|lehn|bodenspiegel|anlehn|\b1[5-9]\d ?cm|\b1[5-9]\d ?x/ } ] },
      { id: 'size', title: 'Wie groß ungefähr?', cols: 3, options: [
        { v: 'klein', label: 'Klein (bis 50 cm)', re: /\b[2-4]\d ?(cm|x)|klein|mini|kosmetik|tisch/, not: /\b[6-9]\d ?(cm|x)|\b1\d\d ?(cm|x)|standspiegel|ganzkoerper/ },
        { v: 'mittel', label: 'Mittel (50–100 cm)', re: /\b[5-9]\d ?(cm|x)|\b100 ?(cm|x)/, not: /standspiegel|ganzkoerper|\b1[2-9]\d ?(cm|x)/ },
        { v: 'gross', label: 'Groß (über 100 cm)', re: /\b1\d\d ?(cm|x)|gross|xl|standspiegel|ganzkoerper|xxl/ } ] } ],
    kerze: [
      { id: 'form', title: 'Was genau suchst du?', options: [
        { v: 'halter', label: 'Kerzenhalter & -ständer', sub: 'Für Stabkerzen', re: /kerzenhalter|kerzenstaender|kerzenständer|stabkerze|leuchter|candle ?holder|kandelaber/, not: /windlicht|laterne|duftkerze|teelichthalter/ },
        { v: 'windlicht', label: 'Windlicht & Laterne', sub: 'Mit Glas, drinnen & draußen', re: /windlicht|laterne|lantern|teelichthalter|teelicht|hurricane/, not: /stabkerze|kerzenstaender|duftkerze/ },
        { v: 'kerzen', label: 'Kerzen & Duftkerzen', sub: 'Die Kerze selbst', re: /duftkerze|kerze\b|kerzen\b|stumpenkerze|stabkerzen|wachs|soja/, not: /halter|staender|windlicht|laterne/ },
        { v: 'led', label: 'LED & Lichterketten', re: /led|lichterkette|batterie|flackernd/ } ] },
      { id: 'material', title: 'Welches Material gefällt dir?', options: [
        { v: 'metall', label: 'Metall & Gold', re: /metall|eisen|messing|gold|schwarz|stahl|alu|chrom|zink/ }, { v: 'glas', label: 'Glas', re: /\bglas|glass|kristall/ },
        { v: 'keramik', label: 'Keramik & Stein', re: /keramik|steingut|porzellan|marmor|stein\b|beton|travertin/ }, { v: 'holz', label: 'Holz & Naturmaterial', re: /holz|mango|akazie|bambus|rattan|teak/ } ] } ],
    bild: [
      { id: 'form', title: 'Was soll an die Wand?', options: [
        { v: 'bild', label: 'Bild & Poster', sub: 'Mit oder ohne Rahmen', re: /poster|wandbild|bild\b|leinwand|canvas|print|gemaelde|kunstdruck/, not: /akustik|paneel|rahmen\b(?!.*poster)/ },
        { v: 'paneel', label: 'Wand- & Akustikpaneel', re: /paneel|akustik|lamelle|wandverkleidung/ },
        { v: 'rahmen', label: 'Bilderrahmen', re: /bilderrahmen|rahmen\b|fotorahmen/, not: /poster|wandbild|akustik/ },
        { v: 'objekt', label: 'Wandobjekt & Wanddeko', re: /wanddeko|wandobjekt|wandskulptur|wandhaken|wandteller|makramee|wandbehang|wanduhr/ } ] },
      { id: 'size', title: 'Welches Format?', cols: 3, options: [
        { v: 'klein', label: 'Klein (bis 40 cm)', re: /\b[1-3]\d ?x ?[1-4]\d|\b40 ?x ?[2-5]\d|a4|a3|klein/ },
        { v: 'mittel', label: 'Mittel (50–80 cm)', re: /\b[5-7]\d ?x|\b80 ?x|a2|a1/ },
        { v: 'gross', label: 'Groß (ab 90 cm)', re: /\b(9\d|1\d\d|2\d\d) ?x|xl|xxl|gross|paneel|akustik/ } ] } ],
    pflanze: [
      { id: 'form', title: 'Was suchst du?', options: [
        { v: 'kunstpflanze', label: 'Kunstpflanze groß', sub: 'Bodenpflanze, Baum, Olive', re: /kunstpflanze|kunstbaum|olivenbaum|monstera|palme|ficus|bodenpflanze|\b1\d\d ?cm|\b[8-9]\d ?cm/, not: /topf\b(?!.*pflanze)|uebertopf|kuebel|staender/ },
        { v: 'klein', label: 'Kunstpflanze klein', sub: 'Für Regal, Tisch, Fensterbank', re: /kunstpflanze|kunstblume|sukkulente|kaktus|eukalyptus|pampas|trockenblume|zweig|bund|\b[1-5]\d ?cm/, not: /uebertopf|kuebel|staender|olivenbaum|\b1\d\d ?cm/ },
        { v: 'topf', label: 'Übertopf & Pflanzkübel', re: /uebertopf|blumentopf|pflanzkuebel|kuebel|topf\b|planter|pflanzgefaess/, not: /kunstpflanze|kunstblume|staender/ },
        { v: 'staender', label: 'Pflanzenständer & Hocker', re: /pflanzenstaender|blumenstaender|staender|hocker|etagere|pflanzenregal/ } ] } ]
  };
  function dekoDetailScore(p, a, r) {
    var det = DEKO_DETAIL[a.art];
    if (!det) return 0;
    var pool = txt(p) + ' ' + norm((p.sz || []).join(' '));
    for (var i = 0; i < det.length; i++) {
      var q = det[i], v = a[q.id];
      if (!v || v === '__skip') continue;
      var o = q.options.filter(function (x) { return x.v === v; })[0];
      if (!o) continue;
      if (o.re && o.re.test(pool)) { r.score += 4; r.reasons.push(o.label); }
      else if (o.not && o.not.test(pool)) return null;
      else r.score -= 1;
    }
    return 0;
  }

  // ---------- Gruppen & Flows ----------
  var GROUPS = {
    betten: {
      label: 'Bett', sub: 'Boxspring, Polster, Holz', file: 'cx-quiz-betten.json',
      intro: 'Ein paar kurze Fragen – wir finden das Bett, das wirklich passt.',
      steps: function (a) {
        var s = [];
        s.push({ id: 'art', title: 'Welche Art Bett soll es sein?', type: 'single', cols: 2, options: [
          { v: 'boxspring', label: 'Boxspringbett', sub: 'Mit Matratze & Topper, hoher Einstieg' },
          { v: 'polster', label: 'Polsterbett', sub: 'Gestell ohne Matratze, flacher' },
          { v: 'holz', label: 'Holzbett' },
          { v: 'elektrisch', label: 'Elektrisch verstellbar' },
          SKIP] });
        s.push({ id: 'wer', title: 'Für wen ist das Bett?', type: 'single', cols: 2, options: [
          { v: '1', label: '1 Person', s: 'für 1 Person' }, { v: '2', label: '2 Personen', s: 'für 2 Personen' }, { v: 'fam', label: 'Familie', sub: 'Kinder schlafen mit', s: 'für die Familie' }, { v: 'gast', label: 'Gästezimmer', s: 'fürs Gästezimmer' }] });
        s.push({ id: 'size', title: 'Welche Liegefläche?', hint: 'Breite × Länge in cm', type: 'single', cols: 3, options: [
          { v: '90x200', label: '90 × 200', s: '90 × 200 cm' }, { v: '100x200', label: '100 × 200', s: '100 × 200 cm' }, { v: '120x200', label: '120 × 200', s: '120 × 200 cm' }, { v: '140x200', label: '140 × 200', s: '140 × 200 cm' },
          { v: '160x200', label: '160 × 200', s: '160 × 200 cm' }, { v: '180x200', label: '180 × 200', s: '180 × 200 cm' }, { v: '200x200', label: '200 × 200', s: '200 × 200 cm' }, { v: '200x220', label: '200 × 220', s: '200 × 220 cm' },
          { v: '__skip', label: 'Weiß ich nicht' }] });
        s.push(spaceStep('platz', 'Wie viel Platz hast du für das Bett?', [{ k: 'b', label: 'Breite (cm)' }, { k: 'l', label: 'Länge (cm)' }]));
        s.push({ id: 'stau', title: 'Brauchst du Stauraum im Bett?', type: 'single', cols: 3, options: [
          { v: 'ja', label: 'Ja, bitte', sub: 'Bettkasten oder Schubladen', s: 'mit Stauraum' }, { v: 'nein', label: 'Nein', s: 'ohne Stauraum' }, SKIP] });
        s.push(styleStep('stil', 'polster'));
        s.push({ id: 'bezug', title: 'Welcher Bezug gefällt dir?', type: 'single', cols: 3, options: FABRICS.map(function (f) { return { v: f.v, label: f.label }; }).concat([SKIP]) });
        s.push(colorStep('farbe'));
        if (a.art !== 'polster' && a.art !== 'holz') {
          s.push({ id: 'haerte', title: 'Wie fest soll die Matratze sein?', type: 'single', cols: 3, options: [
            { v: 'weich', label: 'Weich', sub: 'H2 – bis ca. 80 kg', s: 'eher weich' }, { v: 'mittel', label: 'Mittel', sub: 'H3 – 80 bis 110 kg', s: 'mittelfest' }, { v: 'fest', label: 'Fest', sub: 'H4 – ab 110 kg', s: 'eher fest' }, SKIP] });
        }
        s.push(budgetStep('budget', [800, 1200, 1800, 2500, 4000]));
        return s;
      },
      score: function (p, a) {
        var r = { reasons: [], score: 0 };
        var t = txt(p);
        if (/hundebett|kinderbett|hochbett|babybett|minecraft|sofa|matratze|lattenrost|topper/.test(norm(p.cat) + ' ' + norm(p.t)) && !/boxspring|polsterbett/.test(norm(p.t))) return null;
        if (a.art === 'boxspring' && !/boxspring/.test(t)) return null;
        if (a.art === 'polster' && !/polsterbett/.test(t)) return null;
        if (a.art === 'holz' && !/holz|massiv|eiche|kiefer|buche/.test(t)) return null;
        if (a.art === 'elektrisch' && !/elektr|motor|verstellbar/.test(t)) return null;
        if (a.art === 'boxspring' && /elektr/.test(norm(p.cat))) r.score -= 1;
        // Größe: gewählt, sonst aus „für wen“ abgeleitet – und wenn Platz angegeben ist, die größte lieferbare Größe, die passt
        var sizes = (p.sz || []).map(function (x) { return x.replace(/\s|cm/g, ''); });
        var size = a.size && a.size !== '__skip' ? a.size : null;
        var maxW = a.platz && a.platz.b ? a.platz.b : null;
        if (!size) {
          var wantW = { '1': 140, '2': 180, fam: 200, gast: 140 }[a.wer] || 160;
          if (maxW) wantW = Math.min(wantW, maxW);
          var fitting = sizes.map(sizeWidth).filter(function (w) { return w && w <= wantW; });
          var best = fitting.length ? Math.max.apply(null, fitting) : null;
          if (best) size = sizes.filter(function (x) { return sizeWidth(x) === best; })[0];
        }
        if (size) {
          if (sizes.length) {
            var exact = sizes.indexOf(size) >= 0, w = sizeWidth(size);
            var near = sizes.some(function (x) { var sw = sizeWidth(x); return sw && Math.abs(sw - w) <= 20; });
            if (exact) { r.score += 6; r.reasons.push(size.replace('x', ' × ') + ' cm lieferbar'); }
            else if (near && !(a.size && a.size !== '__skip')) { r.score += 2; }
            else if (a.size && a.size !== '__skip') return null;
          } else if (a.size && a.size !== '__skip') {
            return null;
          }
        }
        // Platz
        if (a.platz && (a.platz.b || a.platz.l)) {
          var pw = bedWidth(p, size), pl = bedLength(p, size);
          if (a.platz.b && pw && pw > a.platz.b) return null;
          if (a.platz.l && pl && pl > a.platz.l) return null;
          if ((a.platz.b && pw) || (a.platz.l && pl)) { r.score += 3; r.reasons.push('Passt in deinen Platz' + (pw || pl ? ' (' + [pw ? pw + ' cm breit' : null, pl ? pl + ' cm lang' : null].filter(Boolean).join(', ') + ')' : '')); }
        }
        // Stauraum
        var hasStorage = (p.stau && !/kein/i.test(p.stau)) || has(p.ex, /stauraum|bettkasten|schublade/) || /bettkasten|stauraum|schublade/.test(t);
        if (a.stau === 'ja') { if (!hasStorage) return null; r.score += 4; r.reasons.push(p.stau && !/kein/i.test(p.stau) ? 'Stauraum: ' + p.stau : 'Mit Stauraum'); }
        if (a.stau === 'nein' && hasStorage) r.score -= 2;
        STYLE_SCORE(p, a, r);
        // Bezug
        if (a.bezug && a.bezug !== '__skip') { var fm = fabricMatch(p, a.bezug); if (fm) { r.score += 4; r.reasons.push('Bezug: ' + fm); } else r.score -= 1; }
        // Farbe
        if (a.farbe && a.farbe.length && a.farbe[0] !== '__skip') { var cm = colorMatch(p, a.farbe); if (cm) { r.score += 4; r.reasons.push('In ' + cm); } else r.score -= 2; }
        // Härtegrad
        if (a.haerte && a.haerte !== '__skip') {
          var hre = { weich: /h2|weich|soft/, mittel: /h3|mittel|medium/, fest: /h4|h5|fest|hart|firm/ }[a.haerte];
          var pool = (p.hg || []).concat([p.mt || '', p.mtyp || '']);
          if (has(pool, hre)) { r.score += 3; r.reasons.push('Härtegrad passend'); }
          else if (p.q && p.q.q5 && has(p.q.q5, { weich: /soft|weich/, mittel: /medium|mittel/, fest: /hard|firm|fest/ }[a.haerte])) { r.score += 2; }
        }
        // Budget
        if (a.budget && a.budget !== '__skip') {
          var b = Number(a.budget);
          if (p.pmin == null) return null;
          if (p.pmin <= b) { r.score += 3; r.reasons.push('Im Budget'); }
          else if (p.pmin <= b * 1.15) { r.score -= 1; r.near = true; }
          else return null;
        }
        return r;
      }
    },

    sofas: {
      label: 'Sofa & Sessel', sub: 'Sofas, Ecksofas, Sessel, Liegen', file: 'cx-quiz-sofas.json',
      steps: function (a) {
        var s = [];
        s.push({ id: 'art', title: 'Was suchst du?', type: 'single', cols: 2, options: [
          { v: 'sofa', label: 'Sofa' }, { v: 'sessel', label: 'Sessel' }, { v: 'liege', label: 'Relaxliege' }, { v: 'bank', label: 'Sitzbank & Hocker' }] });
        if (a.art === 'sofa' || !a.art) {
          s.push({ id: 'form', title: 'Welche Form soll das Sofa haben?', type: 'single', cols: 2, options: [
            { v: '2', label: '2-Sitzer' }, { v: '3', label: '3-Sitzer' }, { v: 'l', label: 'Ecksofa (L-Form)' }, { v: 'u', label: 'Wohnlandschaft (U-Form)' }, SKIP] });
          s.push(spaceStep('platz', 'Wie viel Platz hast du?', [{ k: 'b', label: 'Breite (cm)' }, { k: 't', label: 'Tiefe (cm)' }]));
          s.push({ id: 'extras', title: 'Welche Extras sind dir wichtig?', hint: 'Mehrere möglich.', type: 'multi', cols: 2, options: [
            { v: 'schlaf', label: 'Schlaffunktion' }, { v: 'stau', label: 'Stauraum' }, { v: 'lehne', label: 'Verstellbare Lehnen' }, { v: 'elektrisch', label: 'Elektrisch verstellbar' }, SKIP] });
          s.push({ id: 'sitz', title: 'Wie sitzt du am liebsten?', type: 'single', cols: 3, options: [
            { v: 'tief', label: 'Tief & lounging', sub: 'Sitztiefe ab 65 cm', s: 'tiefe Sitzfläche' }, { v: 'normal', label: 'Klassisch', s: 'klassische Sitztiefe' }, { v: 'aufrecht', label: 'Aufrecht & kompakt', sub: 'Sitztiefe bis 55 cm', s: 'aufrechtes Sitzen' }, SKIP] });
        } else {
          s.push(spaceStep('platz', 'Wie viel Platz hast du?', [{ k: 'b', label: 'Breite (cm)' }, { k: 't', label: 'Tiefe (cm)' }]));
        }
        s.push(styleStep('stil', 'polster'));
        s.push({ id: 'bezug', title: 'Welcher Bezug gefällt dir?', type: 'single', cols: 3, options: FABRICS.map(function (f) { return { v: f.v, label: f.label }; }).concat([SKIP]) });
        s.push(colorStep('farbe'));
        s.push(budgetStep('budget', a.art === 'sessel' ? [300, 500, 800, 1200] : [800, 1200, 1800, 2500, 4000]));
        return s;
      },
      score: function (p, a) {
        var r = { reasons: [], score: 0 };
        var t = txt(p), cat = norm(p.cat);
        if (/garten|outdoor|balkon|terrasse|kinder|minecraft|hund/.test(cat + ' ' + norm(p.t))) return null;
        if (a.art === 'sofa' && (!/sofa|couch|wohnlandschaft/.test(cat + ' ' + norm(p.t)) || /sessel|hocker|bank/.test(norm(p.t)))) return null;
        if (a.art === 'sessel' && !/sessel|armchair/.test(cat + ' ' + norm(p.t))) return null;
        if (a.art === 'liege' && !/liege|recamiere|daybed/.test(cat + ' ' + norm(p.t))) return null;
        if (a.art === 'bank' && !/bank|hocker|pouf|ottoman/.test(cat + ' ' + norm(p.t))) return null;
        if (a.form && a.form !== '__skip') {
          var f = norm(p.form || '') + ' ' + norm(p.t) + ' ' + norm((p.tags || []).join(' '));
          var want = { '2': /2 ?sitzer|2er|zweisitzer/, '3': /3 ?sitzer|3er|dreisitzer/, l: /l ?- ?form|l-form|ecksofa|chaiselon|ottomane/, u: /u ?- ?form|u-form|wohnlandschaft|xxl/ }[a.form];
          if (want.test(f)) { r.score += 5; r.reasons.push({ '2': '2-Sitzer', '3': '3-Sitzer', l: 'Ecksofa', u: 'Wohnlandschaft' }[a.form]); }
          else if (p.form) return null; else r.score -= 2;
        }
        if (a.platz && (a.platz.b || a.platz.t)) {
          var pw = longSide(p), pd = shortSide(p);
          if (a.platz.b && pw && pw > a.platz.b) return null;
          if (a.platz.t && pd && pd > a.platz.t) return null;
          if ((a.platz.b && pw) || (a.platz.t && pd)) { r.score += 3; r.reasons.push(fitReason(pw, pd)); }
        }
        if (a.extras && a.extras.length && a.extras[0] !== '__skip') {
          var ex = norm((p.ex || []).join(' ') + ' ' + p.t);
          a.extras.forEach(function (e) {
            var re = { schlaf: /schlaf/, stau: /stauraum|bettkasten/, lehne: /verstellbar|lehne|kopfst/, elektrisch: /elektr|motor|relax/ }[e];
            if (re && re.test(ex)) { r.score += 3; r.reasons.push({ schlaf: 'Schlaffunktion', stau: 'Stauraum', lehne: 'Verstellbare Lehnen', elektrisch: 'Elektrisch' }[e]); }
            else if (e === 'schlaf' || e === 'elektrisch') r.hard = (r.hard || 0) + 1;
          });
          if (r.hard) return null;
        }
        if (a.sitz && a.sitz !== '__skip' && p.d && typeof p.d.st === 'number') {
          var st = p.d.st, ok = a.sitz === 'tief' ? st >= 65 : a.sitz === 'aufrecht' ? st <= 55 : st > 55 && st < 65;
          if (ok) { r.score += 3; r.reasons.push('Sitztiefe ' + st + ' cm'); } else r.score -= 1;
        }
        STYLE_SCORE(p, a, r);
        if (a.bezug && a.bezug !== '__skip') { var fm = fabricMatch(p, a.bezug); if (fm) { r.score += 4; r.reasons.push('Bezug: ' + fm); } else r.score -= 1; }
        if (a.farbe && a.farbe.length && a.farbe[0] !== '__skip') { var cm = colorMatch(p, a.farbe); if (cm) { r.score += 4; r.reasons.push('In ' + cm); } else r.score -= 2; }
        if (a.budget && a.budget !== '__skip') {
          var b = Number(a.budget);
          if (p.pmin == null) return null;
          if (p.pmin <= b) { r.score += 3; r.reasons.push('Im Budget'); } else if (p.pmin <= b * 1.15) { r.score -= 1; r.near = true; } else return null;
        }
        return r;
      }
    },

    schlafen: {
      label: 'Matratze & Schlafen', sub: 'Matratzen, Topper, Kissen, Bettwäsche', file: 'cx-quiz-schlafen.json',
      steps: function (a) {
        var s = [];
        s.push({ id: 'art', title: 'Was brauchst du?', type: 'single', cols: 2, options: [
          { v: 'matratze', label: 'Matratze' }, { v: 'topper', label: 'Topper' }, { v: 'kissen', label: 'Nackenkissen' }, { v: 'lattenrost', label: 'Lattenrost' }, { v: 'bettwaren', label: 'Bettdecke & Bettwäsche' }] });
        if (a.art !== 'kissen') {
          s.push({ id: 'size', title: 'Welche Größe?', hint: 'Breite × Länge in cm', type: 'single', cols: 3, options: [
            { v: '80x200', label: '80 × 200' }, { v: '90x200', label: '90 × 200' }, { v: '100x200', label: '100 × 200' }, { v: '120x200', label: '120 × 200' }, { v: '140x200', label: '140 × 200' },
            { v: '160x200', label: '160 × 200' }, { v: '180x200', label: '180 × 200' }, { v: '200x200', label: '200 × 200' }, SKIP] });
        }
        if (a.art === 'matratze' || a.art === 'topper') {
          s.push({ id: 'haerte', title: 'Wie fest soll es sein?', type: 'single', cols: 3, options: [
            { v: 'weich', label: 'Weich', sub: 'H2 – bis ca. 80 kg' }, { v: 'mittel', label: 'Mittel', sub: 'H3 – 80 bis 110 kg' }, { v: 'fest', label: 'Fest', sub: 'H4 – ab 110 kg' }, SKIP] });
          s.push({ id: 'typ', title: 'Welche Art bevorzugst du?', type: 'single', cols: 2, options: [
            { v: 'kaltschaum', label: 'Kaltschaum', sub: 'Anpassungsfähig, leise' }, { v: 'feder', label: 'Taschenfederkern', sub: 'Stützend, gut belüftet' }, { v: 'visco', label: 'Visco / Memory', sub: 'Druckentlastend' }, { v: 'gel', label: 'Gel & Latex', sub: 'Kühlend, elastisch' }, SKIP] });
        }
        s.push(budgetStep('budget', a.art === 'matratze' ? [300, 500, 800, 1200] : [100, 200, 400]));
        return s;
      },
      score: function (p, a) {
        var r = { reasons: [], score: 0 }, t = txt(p);
        if (a.art && !typeOk(p, TYPES.schlafen[a.art])) return null;
        if (a.size && a.size !== '__skip') {
          if (p.sz && p.sz.length) { if (!(p.sz || []).some(function (s) { return s.replace(/\s|cm/g, '') === a.size; })) return null; r.score += 5; r.reasons.push(a.size.replace('x', ' × ') + ' cm'); }
        }
        if (a.haerte && a.haerte !== '__skip') {
          var hre = { weich: /h2|weich|soft/, mittel: /h3|mittel|medium/, fest: /h4|h5|fest|hart|firm/ }[a.haerte];
          if (has((p.hg || []).concat([p.mtyp || '', p.ttyp || '', p.t]), hre)) { r.score += 4; r.reasons.push('Härtegrad passend'); } else if (p.hg && p.hg.length) return null;
        }
        if (a.typ && a.typ !== '__skip') {
          var tre = { kaltschaum: /kaltschaum|schaum|foam/, feder: /federkern|taschenfeder|bonnell|pocket/, visco: /visco|memory|gelschaum/, gel: /gel|latex/ }[a.typ];
          if (tre.test(t)) { r.score += 4; r.reasons.push({ kaltschaum: 'Kaltschaum', feder: 'Federkern', visco: 'Visco', gel: 'Gel / Latex' }[a.typ]); } else r.score -= 1;
        }
        if (a.budget && a.budget !== '__skip') { var b = Number(a.budget); if (p.pmin == null) return null; if (p.pmin <= b) { r.score += 3; r.reasons.push('Im Budget'); } else if (p.pmin <= b * 1.15) { r.near = true; r.score -= 1; } else return null; }
        return r;
      }
    },

    garten: {
      label: 'Garten & Balkon', sub: 'Lounges, Essgruppen, Liegen, Grills', file: 'cx-quiz-garten.json',
      steps: function (a) {
        var s = [];
        s.push({ id: 'art', title: 'Was suchst du für draußen?', type: 'single', cols: 2, options: [
          { v: 'lounge', label: 'Lounge & Sofa' }, { v: 'essen', label: 'Essgruppe & Tische' }, { v: 'sitzen', label: 'Stühle, Bänke & Sessel' }, { v: 'liegen', label: 'Liegen & Hängematten' },
          { v: 'balkon', label: 'Balkon-Set' }, { v: 'feuer', label: 'Feuer, Grill & Wärme' }, { v: 'schatten', label: 'Sonnenschirm & Pergola' }, { v: 'deko', label: 'Deko, Licht & Töpfe' }] });
        if (['lounge', 'essen', 'sitzen', 'liegen', 'balkon'].indexOf(a.art) >= 0) {
          s.push(spaceStep('platz', 'Wie viel Platz hast du?', [{ k: 'b', label: 'Breite (cm)' }, { k: 't', label: 'Tiefe (cm)' }]));
        }
        s.push(styleStep('stil', 'garten'));
        s.push({ id: 'material', title: 'Welches Material gefällt dir?', type: 'single', cols: 2, options: [
          { v: 'polyrattan', label: 'Polyrattan & Geflecht' }, { v: 'holz', label: 'Holz (Teak, Akazie)' }, { v: 'metall', label: 'Aluminium & Metall' }, { v: 'textil', label: 'Textil & Polster' }, SKIP] });
        s.push(colorStep('farbe'));
        s.push(budgetStep('budget', [200, 500, 1000, 2000, 3500]));
        return s;
      },
      score: function (p, a) {
        var r = { reasons: [], score: 0 }, t = txt(p);
        if (a.art && !typeOk(p, TYPES.garten[a.art])) return null;
        if (a.art === 'essen' && /beistelltisch|couchtisch/.test(t)) r.score -= 2;
        if (a.platz && (a.platz.b || a.platz.t)) {
          var pw = longSide(p), pd = shortSide(p);
          if (a.platz.b && pw && pw > a.platz.b) return null;
          if (a.platz.t && pd && pd > a.platz.t) return null;
          if ((a.platz.b && pw) || (a.platz.t && pd)) { r.score += 3; r.reasons.push(fitReason(pw, pd)); }
        }
        STYLE_SCORE(p, a, r);
        if (a.material && a.material !== '__skip') { var mm = materialMatch(p, a.material); if (mm) { r.score += 4; r.reasons.push(mm); } else r.score -= 1; }
        if (a.farbe && a.farbe.length && a.farbe[0] !== '__skip') { var cm = colorMatch(p, a.farbe); if (cm) { r.score += 4; r.reasons.push('In ' + cm); } else r.score -= 2; }
        if (a.budget && a.budget !== '__skip') { var b = Number(a.budget); if (p.pmin == null) return null; if (p.pmin <= b) { r.score += 3; r.reasons.push('Im Budget'); } else if (p.pmin <= b * 1.15) { r.near = true; r.score -= 1; } else return null; }
        return r;
      }
    },

    wohnen: {
      label: 'Möbel', sub: 'Tische, Stühle, Schränke, Regale, Lampen', file: 'cx-quiz-wohnen.json',
      steps: function (a) {
        var s = [];
        s.push({ id: 'art', title: 'Welches Möbelstück suchst du?', type: 'single', cols: 2, options: [
          { v: 'esstisch', label: 'Esstisch' }, { v: 'couchtisch', label: 'Couch- & Beistelltisch' }, { v: 'stuhl', label: 'Stühle & Hocker' }, { v: 'kommode', label: 'Kommode & Sideboard' },
          { v: 'schrank', label: 'Schrank & Garderobe' }, { v: 'regal', label: 'Regal & Vitrine' }, { v: 'tv', label: 'TV-Möbel & Wohnwand' }, { v: 'lampe', label: 'Lampen & Leuchten' }, { v: 'nachttisch', label: 'Nachttisch' }] });
        if (a.art !== 'lampe') s.push(spaceStep('platz', 'Wie viel Platz hast du dafür?', [{ k: 'b', label: 'Breite (cm)' }, { k: 'h', label: 'Höhe (cm)' }]));
        s.push(styleStep('stil', 'moebel'));
        s.push({ id: 'material', title: 'Welches Material gefällt dir?', type: 'single', cols: 2, options: [
          { v: 'holz', label: 'Holz' }, { v: 'stein', label: 'Marmor & Stein' }, { v: 'metall', label: 'Metall' }, { v: 'glas', label: 'Glas' }, { v: 'textil', label: 'Textil & Polster' }, SKIP] });
        s.push(colorStep('farbe'));
        s.push(budgetStep('budget', [150, 300, 600, 1000, 2000]));
        return s;
      },
      score: function (p, a) {
        var r = { reasons: [], score: 0 }, t = txt(p);
        if (a.art && !typeOk(p, TYPES.wohnen[a.art])) return null;
        if (a.platz && (a.platz.b || a.platz.h)) {
          var pw = longSide(p), ph = dim(p, 'h');
          if (a.platz.b && pw && pw > a.platz.b) return null;
          if (a.platz.h && ph && ph > a.platz.h) return null;
          if ((a.platz.b && pw) || (a.platz.h && ph)) { r.score += 3; r.reasons.push('Passt in deinen Platz' + (pw ? ' (' + pw + ' cm breit' + (ph ? ', ' + ph + ' cm hoch' : '') + ')' : '')); }
        }
        STYLE_SCORE(p, a, r);
        if (a.material && a.material !== '__skip') { var mm = materialMatch(p, a.material); if (mm) { r.score += 4; r.reasons.push(mm); } else r.score -= 1; }
        if (a.farbe && a.farbe.length && a.farbe[0] !== '__skip') { var cm = colorMatch(p, a.farbe); if (cm) { r.score += 4; r.reasons.push('In ' + cm); } else r.score -= 2; }
        if (a.budget && a.budget !== '__skip') { var b = Number(a.budget); if (p.pmin == null) return null; if (p.pmin <= b) { r.score += 3; r.reasons.push('Im Budget'); } else if (p.pmin <= b * 1.15) { r.near = true; r.score -= 1; } else return null; }
        return r;
      }
    },

    deko: {
      label: 'Deko & Textilien', sub: 'Kissen, Teppiche, Vasen, Spiegel, Licht', file: 'cx-quiz-deko.json', extra: ['schlafen'],
      steps: function (a) {
        var s = [];
        s.push({ id: 'art', title: 'Was suchst du?', type: 'single', cols: 2, options: [
          { v: 'kissen', label: 'Kissen & Decken' }, { v: 'teppich', label: 'Teppich' }, { v: 'vase', label: 'Vasen & Schalen' }, { v: 'kerze', label: 'Kerzen & Kerzenhalter' },
          { v: 'spiegel', label: 'Spiegel' }, { v: 'bild', label: 'Bilder & Wandpaneele' }, { v: 'pflanze', label: 'Pflanzen & Töpfe' }, { v: 'tisch', label: 'Geschirr & Tischdeko' }, { v: 'textil', label: 'Gardinen, Matten & Bad' }] });
        if (a.art === 'teppich') {
          s.push({ id: 'size', title: 'Welche Größe?', type: 'single', cols: 3, options: [
            { v: '80x150', label: 'bis 80 × 150' }, { v: '120x170', label: '120 × 170' }, { v: '160x230', label: '160 × 230' }, { v: '200x290', label: '200 × 290' }, { v: 'rund', label: 'Rund' }, { v: 'laeufer', label: 'Läufer' }, SKIP] });
        }
        // Fragen passend zur gewählten Art (Vase: Form & Material, Kissen: Größe & Stoff, Spiegel: Form & Größe …) –
        // der allgemeine Einrichtungsstil wird nur gefragt, wo es keine spezifischeren Fragen gibt.
        var det = DEKO_DETAIL[a.art];
        if (det) {
          det.forEach(function (q) { s.push({ id: q.id, title: q.title, type: 'single', cols: q.cols || 2, options: q.options.map(function (o) { return { v: o.v, label: o.label, sub: o.sub }; }).concat([SKIP]) }); });
        } else {
          s.push(styleStep('stil', 'deko'));
        }
        s.push(colorStep('farbe'));
        s.push(budgetStep('budget', [30, 60, 120, 250, 500]));
        return s;
      },
      score: function (p, a) {
        var r = { reasons: [], score: 0 }, t = txt(p);
        if (a.art && !typeOk(p, TYPES.deko[a.art])) return null;
        if (dekoDetailScore(p, a, r) === null) return null;
        if (a.size && a.size !== '__skip') {
          var szs = (p.sz || []).map(function (x) { return norm(x); }).join(' ') + ' ' + norm(p.t);
          var ok = a.size === 'rund' ? /rund|round|ø|durchmesser/.test(szs) : a.size === 'laeufer' ? /laeufer|80 ?x ?(2|3)\d\d|60 ?x/.test(szs) : (function () { var w = sizeWidth(a.size); var ws = (p.sz || []).map(sizeWidth).filter(Boolean); return ws.some(function (x) { return Math.abs(x - w) <= 25; }); })();
          if (ok) { r.score += 5; r.reasons.push('Größe passt'); } else if (p.sz && p.sz.length) return null;
        }
        STYLE_SCORE(p, a, r);
        if (a.farbe && a.farbe.length && a.farbe[0] !== '__skip') { var cm = colorMatch(p, a.farbe); if (cm) { r.score += 4; r.reasons.push('In ' + cm); } else r.score -= 2; }
        if (a.budget && a.budget !== '__skip') { var b = Number(a.budget); if (p.pmin == null) return null; if (p.pmin <= b) { r.score += 3; r.reasons.push('Im Budget'); } else if (p.pmin <= b * 1.15) { r.near = true; r.score -= 1; } else return null; }
        return r;
      }
    },

    kinder: {
      label: 'Kinder', sub: 'Kinderbetten, Hochbetten, Kindermöbel', file: 'cx-quiz-kinder.json',
      steps: function (a) {
        var s = [];
        s.push({ id: 'art', title: 'Was suchst du fürs Kinderzimmer?', type: 'single', cols: 2, options: [
          { v: 'bett', label: 'Kinderbett' }, { v: 'hochbett', label: 'Hochbett' }, { v: 'sofa', label: 'Kindersofa & Sessel' }, { v: 'tisch', label: 'Tische & Stühle' }, { v: 'deko', label: 'Deko & Textilien' }] });
        if (a.art === 'bett' || a.art === 'hochbett') {
          s.push({ id: 'size', title: 'Welche Liegefläche?', type: 'single', cols: 3, options: [
            { v: '70x140', label: '70 × 140' }, { v: '80x160', label: '80 × 160' }, { v: '80x180', label: '80 × 180' }, { v: '90x200', label: '90 × 200' }, { v: '120x200', label: '120 × 200' }, { v: '140x200', label: '140 × 200' }, SKIP] });
          s.push(spaceStep('platz', 'Wie viel Platz hast du?', [{ k: 'b', label: 'Breite (cm)' }, { k: 'l', label: 'Länge (cm)' }]));
        }
        s.push({ id: 'motiv', title: 'Welches Motiv oder welcher Stil?', type: 'single', cols: 2, options: [
          { v: 'tiere', label: 'Tiere' }, { v: 'fahrzeuge', label: 'Fahrzeuge & Technik' }, { v: 'sport', label: 'Sport' }, { v: 'fantasy', label: 'Fantasie & Weltall' }, { v: 'uni', label: 'Schlicht & einfarbig' }, SKIP] });
        s.push(colorStep('farbe'));
        s.push(budgetStep('budget', [150, 300, 500, 800]));
        return s;
      },
      score: function (p, a) {
        var r = { reasons: [], score: 0 }, t = txt(p);
        if (a.art && !typeOk(p, TYPES.kinder[a.art])) return null;
        if (a.art === 'bett' && /hochbett|etagen/.test(t)) r.score -= 2;
        if (a.size && a.size !== '__skip') {
          if (p.sz && p.sz.length) { var ok = (p.sz || []).some(function (s) { return s.replace(/\s|cm/g, '') === a.size; }); if (!ok) return null; r.score += 5; r.reasons.push(a.size.replace('x', ' × ') + ' cm'); }
        }
        if (a.platz && (a.platz.b || a.platz.l)) {
          var pw = bedWidth(p, a.size !== '__skip' ? a.size : null), pl = bedLength(p, a.size !== '__skip' ? a.size : null);
          if (a.platz.b && pw && pw > a.platz.b) return null;
          if (a.platz.l && pl && pl > a.platz.l) return null;
          if ((a.platz.b && pw) || (a.platz.l && pl)) { r.score += 3; r.reasons.push('Passt in deinen Platz'); }
        }
        if (a.motiv && a.motiv !== '__skip') {
          var pool = norm((p.st || []).concat([p.t, p.stil || '']).join(' '));
          var mre = { tiere: /dog|cat|dino|elephant|farm|tier|hund|katze|baer|bear|bunny|hase|fox|fuchs|lion|loewe|panda|unicorn|einhorn|zebra|leopard/, fahrzeuge: /digger|bagger|fire|feuerwehr|auto|car|truck|traktor|police|polizei|flash|bus|train|zug/, sport: /football|fussball|goal|soccer|basketball|sport/, fantasy: /fairy|fee|cosmos|space|weltraum|rocket|rakete|star|stern|galaxy|magic|zauber|princess|prinzessin|minecraft|energy|flowers|blumen/, uni: /uni|einfarbig|beige|grau|weiss|blau|rosa|gruen|schwarz|natur/ }[a.motiv];
          if (mre.test(pool)) { r.score += 4; r.reasons.push('Motiv passt'); } else if (p.st && p.st.length && a.motiv !== 'uni') r.score -= 2;
        }
        if (a.farbe && a.farbe.length && a.farbe[0] !== '__skip') { var cm = colorMatch(p, a.farbe); if (cm) { r.score += 3; r.reasons.push('In ' + cm); } else r.score -= 1; }
        if (a.budget && a.budget !== '__skip') { var b = Number(a.budget); if (p.pmin == null) return null; if (p.pmin <= b) { r.score += 3; r.reasons.push('Im Budget'); } else if (p.pmin <= b * 1.15) { r.near = true; r.score -= 1; } else return null; }
        return r;
      }
    }
  };

  function STYLE_SCORE(p, a, r) {
    if (!a.stil || a.stil === '__skip') return;
    var m = styleMatch(p, a.stil), st = STYLES.filter(function (x) { return x.v === a.stil; })[0];
    if (m > 0) { r.score += m * 2; r.reasons.push(st.label); }
    else if (m < 0) r.score -= 2;
  }

  // ---------- Ranking ----------
  // Bestseller zuerst: Von allen Produkten, die zu den Antworten passen (harte Kriterien in group.score), kommen die
  // meistverkauften nach vorn – nie Ladenhüter nur wegen Farbe oder Stil. Verkaufszahl = „sold“ (Stück in den letzten
  // 90 Tagen aus den Shop-Analysen, für alle Produkte), ersatzweise s30 (Metafeld, nur Lagerware).
  // Die weichen Punkte (Farbe, Bezug, Stil, Bewertung, Lieferzeit) entscheiden nur noch innerhalb gleicher Verkaufsklasse.
  var MIN_SOLD = 3; // ab so vielen Stück in 90 Tagen zählt ein Produkt als Bestseller-Kandidat
  // Ein Modell nur einmal: „Designer Sofa Lazy 3 Sitzer in Cord“, „OUTLET - Designer Sofa Lazy …“ und „Luxor Samt / Luxor
  // Stoff“ sind für den Kunden dasselbe Produkt. Schlüssel = Produktart + Modellname (erstes Wort im Titel, das weder
  // Art, Bezug, Ausstattung noch Maß ist; römische Ziffern wie „Cozy II“ bleiben Teil des Namens).
  var MODEL_STOP = /^(outlet|designer|premium|luxus|exklusiv|neu|nightsense|luxusbetten24|moduro|flausch|sofa|sofas|ecksofa|ecksofas|bigsofa|big|eckmodul|modul|modular|modularer|sessel|hocker|beistellhocker|pouf|relaxliege|liege|liegen|boxspringbett|boxspring|polsterbett|bett|betten|holzbett|kinderbett|hochbett|familienbett|nachttisch|tisch|esstisch|couchtisch|beistelltisch|schreibtisch|stuhl|stühle|stuehle|bank|sitzbank|essbank|schrank|kleiderschrank|hängeschrank|haengeschrank|kommode|sideboard|highboard|lowboard|tv|vitrine|garderobe|regal|lampe|leuchte|teppich|kissen|zierkissen|kissenbezug|vase|spiegel|matratze|matratzen|topper|bettlaken|laken|bettwäsche|bettwaesche|bettdecke|tagesdecke|lattenrost|decke|taschenfederkern|kaltschaum|visco|gel|sitzer|set|in|mit|und|oder|aus|inkl|aufbau|montage|cord|samt|stoff|kunstleder|leder|echtleder|bouclé|boucle|teddy|chenille|velours|strukturstoff|webstoff|lammfell|kunstfell|baumwolle|schlaffunktion|schlaf|klappfunktion|bettkasten|stauraum|led|usb|elektrisch|verstellbar|ottomane|breiter|breite|links|rechts|xl|xxl|mini|maxi|cm|für|zum|der|die|das|von|beige|grau|hellgrau|dunkelgrau|schwarz|weiß|weiss|braun|blau|grün|gruen|rosa|creme|anthrazit|taupe|terrakotta|senf|petrol|natur|&|-|–|\/)$/;
  function modelKey(p) {
    var words = String(p.t || '').toLowerCase().replace(/[(),.+"„“®™]/g, ' ').split(/[\s\-–\/]+/).filter(Boolean);
    var type = '', model = '';
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (/\d/.test(w)) continue;
      if (MODEL_STOP.test(w)) { if (!type && /sofa|sessel|hocker|pouf|liege|bett|tisch|stuhl|bank|schrank|kommode|regal|lampe|leuchte|teppich|kissen|vase|spiegel|matratze|topper|laken|wäsche|waesche|decke|lattenrost/.test(w)) type = w; continue; }
      model = w;
      if (/^(i{1,3}|iv|v|vi{0,3})$/.test(words[i + 1] || '')) model += ' ' + words[i + 1];
      break;
    }
    return model ? type + '|' + model : 'id|' + p.id;
  }
  function salesBand(n) { return n >= 100 ? 4 : n >= 30 ? 3 : n >= 10 ? 2 : n >= MIN_SOLD ? 1 : 0; }
  function soldOf(p) { return p.sold != null ? p.sold : (p.s30 || 0); }
  function rank(group, products, answers) {
    var scored = [];
    products.forEach(function (p) {
      var r = group.score(p, answers);
      if (!r) return;
      if (answers.farbe && answers.farbe[0] !== '__skip' && colorImage(p, answers.farbe)) r.score += 1; // Bild in Wunschfarbe vorhanden
      if (p.r && p.rc) r.score += Math.min(1.5, (p.r - 3.5) * (p.rc >= 5 ? 1 : 0.5));
      if (p.lt && p.lt <= 7) { r.score += 0.5; }
      r.p = p;
      r.sold = soldOf(p);
      // Beliebtheit zählt mit, aber die Antworten zuerst: ein Bestseller, der nicht passt, darf keinen Treffer verdrängen
      r.score += salesBand(r.sold) * 0.75;
      scored.push(r);
    });
    scored.sort(function (a, b) { return b.score - a.score || b.sold - a.sold; });
    return scored;
  }

  // Wenn mit allen Antworten nichts passt: Kriterien von hinten lockern (Budget → Farbe → Bezug/Material → Platz …)
  var RELAX_ORDER = ['budget', 'farbe', 'bezug', 'material', 'stil', 'motiv', 'sitz', 'haerte', 'typ', 'extras', 'stau', 'platz', 'form', 'size'];
  function rankWithFallback(group, products, answers) {
    var a = Object.assign({}, answers), relaxed = [];
    var res = rank(group, products, a);
    var i = 0;
    while (res.length < 2 && i < RELAX_ORDER.length) {
      var k = RELAX_ORDER[i++];
      if (a[k] == null || a[k] === '__skip') continue;
      delete a[k]; relaxed.push(k);
      res = rank(group, products, a);
    }
    return { results: res, relaxed: relaxed };
  }

  // ---------- UI ----------
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var LABELS = { budget: 'Budget', farbe: 'Farbe', bezug: 'Bezug', material: 'Material', stil: 'Look', motiv: 'Motiv', sitz: 'Sitzgefühl', haerte: 'Härtegrad', typ: 'Matratzenart', extras: 'Extras', stau: 'Stauraum', platz: 'Platz', form: 'Form', size: 'Größe' };

  function Quiz(root) {
    this.root = root;
    this.stage = root.querySelector('[data-cxq-stage]');
    this.indexUrls = JSON.parse(root.getAttribute('data-cxq-index') || '{}');
    this.cache = {};
    this.reset();
    var self = this;
    root.querySelectorAll('[data-cx-berater-open]').forEach(function (el) { el.addEventListener('click', function () { self.open(); }); });
    root.querySelectorAll('[data-cx-berater-close]').forEach(function (el) { el.addEventListener('click', function () { self.close(); }); });
    // Bild lädt nicht (z. B. Variantenbild fehlt im CDN): erst auf das Hauptbild ausweichen, sonst Fläche leer lassen.
    this.stage.addEventListener('error', function (e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG') return;
      var fb = img.getAttribute('data-fallback');
      if (fb && img.getAttribute('src') !== fb) { img.removeAttribute('data-fallback'); img.src = fb; }
      else { img.style.visibility = 'hidden'; }
    }, true);
    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-cxq-opt]');
      if (opt) { self.choose(opt.getAttribute('data-cxq-opt')); return; }
      var act = e.target.closest('[data-cxq-act]');
      if (act) { self.action(act.getAttribute('data-cxq-act')); }
    });
    root.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cxq-form]');
      if (!form) return;
      e.preventDefault();
      self.submitForm(form);
    });
  }
  Quiz.prototype.reset = function () { this.groupKey = null; this.answers = {}; this.history = []; this.stepIndex = 0; this.products = null; };
  Quiz.prototype.open = function () {
    this.root.classList.add('is-open');
    this.root.querySelector('[data-cx-berater-intro]').setAttribute('aria-hidden', 'true');
    this.root.querySelector('[data-cx-berater-embed]').setAttribute('aria-hidden', 'false');
    var top = this.root.getBoundingClientRect().top;
    if (top < 0) this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (!this.groupKey) this.renderGroups();
  };
  Quiz.prototype.close = function () {
    this.root.classList.remove('is-open');
    this.root.querySelector('[data-cx-berater-intro]').setAttribute('aria-hidden', 'false');
    this.root.querySelector('[data-cx-berater-embed]').setAttribute('aria-hidden', 'true');
    this.reset();
    this.renderGroups();
  };
  Quiz.prototype.steps = function () { return GROUPS[this.groupKey].steps(this.answers); };
  Quiz.prototype.total = function () { return this.groupKey ? this.steps().length + 1 : 7; };
  Quiz.prototype.setStage = function (html, back) {
    var s = this.stage;
    s.classList.remove('is-in');
    s.classList.toggle('is-back', !!back);
    s.innerHTML = html;
    void s.offsetWidth;
    s.classList.add('is-in');
    var first = s.querySelector('input');
    if (first && window.matchMedia('(min-width: 1000px)').matches) first.focus({ preventScroll: true });
  };
  Quiz.prototype.progress = function (n) {
    var total = this.total(), pct = Math.round((n / total) * 100);
    return '<div class="cxq__progress"><span class="cxq__progress-text">Frage ' + n + ' von ' + total + '</span><span class="cxq__bar"><i style="width:' + pct + '%"></i></span></div>';
  };
  Quiz.prototype.renderGroups = function () {
    var html = this.progress(1) +
      '<h3 class="cxq__q">Wofür suchst du gerade etwas?</h3>' +
      '<div class="cxq__opts cxq__opts--2">' +
      Object.keys(GROUPS).map(function (k) { var g = GROUPS[k]; return '<button type="button" class="cxq__opt" data-cxq-opt="' + k + '"><strong>' + esc(g.label) + '</strong>' + (g.sub ? '<small>' + esc(g.sub) + '</small>' : '') + '</button>'; }).join('') +
      '</div>';
    this.setStage(html);
  };
  Quiz.prototype.renderStep = function (back) {
    var steps = this.steps();
    if (this.stepIndex >= steps.length) { this.renderResults(); return; }
    var st = steps[this.stepIndex], a = this.answers, html = this.progress(this.stepIndex + 2);
    html += '<h3 class="cxq__q">' + esc(st.title) + '</h3>' + (st.hint ? '<p class="cxq__hint">' + esc(st.hint) + '</p>' : '');
    if (st.type === 'dims') {
      var vals = a[st.id] || {};
      html += '<form class="cxq__form" data-cxq-form="' + st.id + '"><div class="cxq__fields">' +
        st.fields.map(function (f) { return '<label class="cxq__field"><span>' + esc(f.label) + '</span><input type="number" inputmode="numeric" min="20" max="1000" step="1" name="' + f.k + '" value="' + (vals[f.k] || '') + '" placeholder="z. B. 220"></label>'; }).join('') +
        '</div><div class="cxq__actions"><button type="submit" class="cxq__btn">Weiter</button><button type="button" class="cxq__link" data-cxq-act="skip">Überspringen</button></div></form>';
    } else {
      var sel = a[st.id];
      var selected = function (v) { return st.type === 'multi' ? (sel || []).indexOf(v) >= 0 : sel === v; };
      html += '<div class="cxq__opts cxq__opts--' + (st.cols || 2) + '">' +
        st.options.map(function (o) { return '<button type="button" class="cxq__opt' + (selected(o.v) ? ' is-selected' : '') + (o.v === '__skip' ? ' cxq__opt--skip' : '') + '" data-cxq-opt="' + esc(o.v) + '"><strong>' + esc(o.label) + '</strong>' + (o.sub ? '<small>' + esc(o.sub) + '</small>' : '') + '</button>'; }).join('') +
        '</div>';
      if (st.type === 'multi') html += '<div class="cxq__actions"><button type="button" class="cxq__btn" data-cxq-act="next">Weiter</button></div>';
    }
    html += '<div class="cxq__nav"><button type="button" class="cxq__link" data-cxq-act="back">← Zurück</button></div>';
    this.setStage(html, back);
  };
  Quiz.prototype.choose = function (v) {
    var self = this;
    if (!this.groupKey) {
      this.groupKey = v; this.stepIndex = 0; this.answers = {};
      this.load().catch(function () { });
      this.renderStep();
      return;
    }
    var st = this.steps()[this.stepIndex];
    if (!st) return;
    if (st.type === 'multi') {
      var cur = (this.answers[st.id] || []).slice();
      if (v === '__skip') cur = ['__skip'];
      else { cur = cur.filter(function (x) { return x !== '__skip'; }); var i = cur.indexOf(v); if (i >= 0) cur.splice(i, 1); else cur.push(v); }
      this.answers[st.id] = cur;
      var opts = this.stage.querySelectorAll('[data-cxq-opt]');
      opts.forEach(function (o) { o.classList.toggle('is-selected', cur.indexOf(o.getAttribute('data-cxq-opt')) >= 0); });
      if (v === '__skip') self.next();
      return;
    }
    this.answers[st.id] = v;
    this.next();
  };
  Quiz.prototype.submitForm = function (form) {
    var st = this.steps()[this.stepIndex], vals = {};
    form.querySelectorAll('input').forEach(function (i) { var n = Number(i.value); if (n > 0) vals[i.name] = n; });
    this.answers[st.id] = Object.keys(vals).length ? vals : '__skip';
    this.next();
  };
  Quiz.prototype.next = function () { this.stepIndex += 1; this.renderStep(false); };
  // Slider: Pfeile scrollen um eine Karte, am Rand ausgegraut; auf Touch wird einfach gewischt
  Quiz.prototype.initSlider = function () {
    var wrap = this.stage.querySelector('.cxq__slider-wrap'), track = wrap && wrap.querySelector('[data-cxq-slider]');
    if (!track) return;
    var prev = wrap.querySelector('.cxq__arrow--prev'), next = wrap.querySelector('.cxq__arrow--next');
    function update() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
      wrap.classList.toggle('has-overflow', max > 1);
    }
    wrap.querySelectorAll('[data-cxq-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cardEl = track.querySelector('.cxq__card');
        var step = cardEl ? cardEl.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
        track.scrollBy({ left: step * Number(btn.getAttribute('data-cxq-nav')), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    update();
    setTimeout(update, 300);
  };
  Quiz.prototype.action = function (act) {
    if (act === 'back') {
      if (this.stepIndex === 0) { this.groupKey = null; this.renderGroups(); return; }
      if (this.stepIndex > this.steps().length) this.stepIndex = this.steps().length;
      this.stepIndex -= 1; this.renderStep(true); return;
    }
    if (act === 'skip') { var st = this.steps()[this.stepIndex]; this.answers[st.id] = '__skip'; this.next(); return; }
    if (act === 'next') { var s2 = this.steps()[this.stepIndex]; if (s2.type === 'multi' && !(this.answers[s2.id] || []).length) this.answers[s2.id] = ['__skip']; this.next(); return; }
    if (act === 'restart') { this.reset(); this.renderGroups(); return; }
    if (act === 'more') { this.shown += 3; this.renderResults(true); return; }
  };
  Quiz.prototype.loadOne = function (key) {
    var self = this, url = this.indexUrls[key];
    if (this.cache[key]) return Promise.resolve(this.cache[key]);
    if (!url) return Promise.resolve([]);
    return fetch(url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }).then(function (data) {
      self.cache[key] = data.products || [];
      return self.cache[key];
    }).catch(function () { return []; });
  };
  // Gruppen-Index plus ggf. Zusatz-Indizes (z. B. Deko braucht die Zierkissen/Tagesdecken aus „Schlafen“), ohne Dubletten
  Quiz.prototype.load = function () {
    var self = this, group = GROUPS[this.groupKey], keys = [this.groupKey].concat(group.extra || []);
    return Promise.all(keys.map(function (k) { return self.loadOne(k); })).then(function (lists) {
      var seen = {}, out = [];
      lists.forEach(function (l) { l.forEach(function (p) { if (!seen[p.id]) { seen[p.id] = true; out.push(p); } }); });
      if (!out.length) throw new Error('Kein Index für ' + self.groupKey);
      return out;
    });
  };
  // Kategorie-Link für „Alle … ansehen“ (pro Gruppe und erster Antwort)
  var COLLECTIONS = {
    betten: { boxspring: ['boxspringbetten', 'Boxspringbetten'], polster: ['polsterbetten', 'Polsterbetten'], holz: ['holzbetten', 'Holzbetten'], elektrisch: ['elektrische-boxspringbetten', 'elektrischen Boxspringbetten'], _: ['betten', 'Betten'] },
    sofas: { sofa: ['sofas', 'Sofas'], sessel: ['sessel', 'Sessel'], liege: ['relaxliegen', 'Relaxliegen'], bank: ['sitzbanke', 'Sitzbänke'], _: ['sofas', 'Sofas'] },
    schlafen: { matratze: ['nightsense%E2%84%A2matratzen', 'Matratzen'], topper: ['nightsense%E2%84%A2-topper', 'Topper'], kissen: ['nightsense%E2%84%A2-nackenkissen', 'Nackenkissen'], lattenrost: ['lattenroste', 'Lattenroste'], bettwaren: ['bettwaesche', 'Bettwäsche'], _: ['zubehoer', 'Schlaf-Produkte'] },
    garten: { lounge: ['gartenlounges', 'Gartenlounges'], essen: ['garten-esstische', 'Gartentische'], sitzen: ['garten-sitzmobel', 'Garten-Sitzmöbel'], liegen: ['sonnenliegen', 'Sonnenliegen'], balkon: ['balkonsets', 'Balkonsets'], feuer: ['feuerstellen-grills', 'Feuerstellen & Grills'], schatten: ['sonnenschirme', 'Sonnenschirme'], deko: ['garten-beleuchtung', 'Garten-Deko'], _: ['garten-1', 'Gartenmöbel'] },
    wohnen: { esstisch: ['esstische', 'Esstische'], couchtisch: ['couchtische', 'Couchtische'], stuhl: ['stuehle', 'Stühle'], kommode: ['kommoden', 'Kommoden'], schrank: ['schraenke', 'Schränke'], regal: ['regal', 'Regale'], tv: ['lowboard', 'Lowboards'], lampe: ['lampen', 'Lampen'], nachttisch: ['nachttische', 'Nachttische'], _: ['wohnzimmermoebel', 'Möbel'] },
    deko: { kissen: ['zierkissen', 'Zierkissen'], teppich: ['teppiche', 'Teppiche'], vase: ['vasen', 'Vasen'], kerze: ['kerzenhalter', 'Kerzenhalter'], spiegel: ['spiegel', 'Spiegel'], bild: ['poster', 'Poster'], pflanze: ['kunstpflanzen', 'Kunstpflanzen'], tisch: ['geschirr-besteck-glaser', 'Geschirr'], textil: ['textilien', 'Textilien'], _: ['wohn-accessoires', 'Wohnaccessoires'] },
    kinder: { bett: ['kinderbetten', 'Kinderbetten'], hochbett: ['hochbetten', 'Hochbetten'], sofa: ['kindersofas', 'Kindersofas'], tisch: ['kindertische', 'Kindertische'], _: ['alles-fur-kinder', 'Kinderprodukte'] }
  };
  // Antworten als Zusammenfassung („Boxspringbett · 180 × 200 · Stauraum · Samt · Grau · bis 1.800 €“)
  Quiz.prototype.summary = function () {
    var self = this, out = [];
    this.steps().forEach(function (st) {
      var a = self.answers[st.id];
      if (a == null || a === '__skip' || (Array.isArray(a) && (!a.length || a[0] === '__skip'))) return;
      if (st.type === 'dims') { out.push(Object.keys(a).map(function (k) { return a[k] + ' cm'; }).join(' × ') + ' Platz'); return; }
      var vals = Array.isArray(a) ? a : [a];
      vals.forEach(function (v) { var o = (st.options || []).filter(function (x) { return x.v === v; })[0]; if (o) out.push(o.s || o.label); });
    });
    return out;
  };
  Quiz.prototype.renderResults = function (keepShown) {
    var self = this, group = GROUPS[this.groupKey];
    if (!keepShown) this.shown = 3;
    this.setStage(this.progress(this.total()) + '<div class="cxq__loading"><span class="cxq__spinner"></span>Ich schaue mich für dich um …</div>');
    this.load().then(function (products) {
      var out = rankWithFallback(group, products, self.answers), res = out.results, a = self.answers;
      var coll = COLLECTIONS[self.groupKey] || {}, c = coll[a.art] || coll._;
      var chips = self.summary();
      var html = '<div class="cxq__result-head"><span class="cxb__kicker">Meine Empfehlung für dich</span>';
      if (!res.length) {
        html += '<h3 class="cxq__q">Dafür habe ich gerade nichts, das wirklich passt.</h3><p class="cxq__hint">Probier es mit etwas weniger Vorgaben – oder stöbere direkt in der Kategorie.</p></div>' +
          '<div class="cxq__actions"><button type="button" class="cxq__btn" data-cxq-act="restart">Nochmal starten</button>' + (c ? '<a class="cxq__link" href="/collections/' + c[0] + '">Alle ' + esc(c[1]) + ' ansehen →</a>' : '') + '</div>';
        self.setStage(html); return;
      }
      var top = res[0];
      html += '<h3 class="cxq__q">' + (res.length === 1 ? 'Das hier passt zu dir' : 'Das passt am besten zu dir') + '</h3>';
      if (chips.length) html += '<p class="cxq__hint">Du suchst: ' + chips.map(esc).join(' · ') + '</p>';
      if (out.relaxed.length) html += '<p class="cxq__note">Für genau diese Kombination gab es nichts – ich habe ' + out.relaxed.map(function (k) { return LABELS[k] || k; }).join(' und ') + ' etwas gelockert.</p>';
      html += '</div>';
      var wanted = a.farbe && a.farbe[0] !== '__skip' ? a.farbe : null;
      function card(r, i, big) {
        var p = r.p, inReason = (r.reasons.filter(function (x) { return /^In /.test(x); })[0] || '').slice(3);
        var ci = colorImage(p, wanted, inReason), img = ci ? imgUrl(ci.url, big ? 800 : 600) : imgUrl(p.img, big ? 800 : 600);
        var fallback = ci && p.img ? imgUrl(p.img, big ? 800 : 600) : '';
        var price = p.pmin != null ? (p.pmax && p.pmax > p.pmin ? 'ab ' : '') + money(p.pmin) : '';
        var why = r.reasons.slice(0, big ? 5 : 3);
        return '<a class="cxq__card' + (big ? ' cxq__card--big' : '') + '" href="/products/' + esc(p.h) + '">' +
          '<span class="cxq__card-media">' + (img ? '<img src="' + esc(img) + '" alt="" decoding="async" loading="' + (i === 0 ? 'eager' : 'lazy') + '"' + (fallback ? ' data-fallback="' + esc(fallback) + '"' : '') + '>' : '') + (i === 0 ? '<span class="cxq__badge">Mein Favorit</span>' : '') + '</span>' +
          '<span class="cxq__card-body"><strong class="cxq__card-title">' + esc(p.t) + (ci ? ' <em>in ' + esc(ci.name) + '</em>' : '') + '</strong>' +
          '<span class="cxq__card-price">' + esc(price) + (r.near ? ' <em>knapp über deinem Budget</em>' : '') + '</span>' +
          (why.length ? '<span class="cxq__why"><b>Passt, weil:</b> ' + why.map(esc).join(' · ') + '</span>' : '') +
          '</span></a>';
      }
      // 5–7 Vorschläge nebeneinander zum Durchwischen (statt einer großen Karte + Raster), damit es wenig Platz braucht
      // jedes Modell nur einmal (Outlet-/Bezugsvarianten zählen als dasselbe Produkt)
      var seen = {};
      var unique = res.filter(function (r) { var k = modelKey(r.p); if (seen[k]) return false; seen[k] = true; return true; });
      // Reihenfolge = Passung (Beliebtheit steckt schon als Bonus im Score) – kein Vorrang für Bestseller, die schlechter passen
      var picks = unique.slice(0, 7);
      html += '<div class="cxq__slider-wrap">' +
        '<button type="button" class="cxq__arrow cxq__arrow--prev" data-cxq-nav="-1" aria-label="Zurück">&#8249;</button>' +
        '<div class="cxq__slider" data-cxq-slider>' + picks.map(function (r, i) { return card(r, i, false); }).join('') + '</div>' +
        '<button type="button" class="cxq__arrow cxq__arrow--next" data-cxq-nav="1" aria-label="Weiter">&#8250;</button>' +
        '</div>';
      html += '<div class="cxq__actions cxq__actions--result">' +
        '<button type="button" class="cxq__link" data-cxq-act="restart">Nochmal starten</button>' +
        (c ? '<a class="cxq__link" href="/collections/' + c[0] + '">Alle ' + esc(c[1]) + ' ansehen →</a>' : '') +
        '</div>';
      self.setStage(html);
      self.initSlider();
    }).catch(function (err) {
      console.error('cx-berater:', err);
      self.setStage('<div class="cxq__result-head"><h3 class="cxq__q">Das hat gerade nicht geklappt.</h3><p class="cxq__hint">Bitte versuch es gleich noch einmal.</p></div><div class="cxq__actions"><button type="button" class="cxq__btn" data-cxq-act="restart">Nochmal starten</button></div>');
    });
  };

  window.CXBerater = { groups: GROUPS, rank: rank, rankWithFallback: rankWithFallback };

  function init() {
    document.querySelectorAll(ROOT_SEL).forEach(function (root) {
      if (root.dataset.cxqReady) return;
      root.dataset.cxqReady = '1';
      var quiz = new Quiz(root);
      // Direktlink /#einrichtungsberater (Footer, Mails): hinscrollen und den Berater gleich öffnen
      if (location.hash === '#einrichtungsberater' && !root.dataset.cxqAuto) {
        root.dataset.cxqAuto = '1';
        setTimeout(function () { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); quiz.open(); }, 150);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
